export function CalculatorDisclaimer() {
  return (
    <div className="mt-6 border border-bronze-600 rounded-[4px] p-4 bg-cream-50/40">
      <p className="font-sans italic text-[12px] leading-relaxed text-charcoal-500">
        Projections shown are hypothetical and for educational purposes only.
        They do not represent guaranteed returns or actual policy performance.
      </p>
    </div>
  );
}

export default CalculatorDisclaimer;